import { dynamic } from '#/utils/dynamic';

export const DynamicSearchVolopsRefinements = dynamic(
  () =>
    import('./SearchVolopsRefinements').then((m) => ({
      default: m.SearchVolopsRefinements,
    })),
  { strategy: 'client-only' },
);
